define('core/utils/function/throttle',[],function () {
    'use strict';

    // Modified Underscore.js throttle implementation
    // Trailing calls can be delayed more than the throttle delay
    return function throttle(func, delay, additionalTrailingDelay) {
        if (!additionalTrailingDelay)
            additionalTrailingDelay = 0;

        var context, args, timeout, result;
        var previous = 0;
        var later = function () {
            previous = new Date();
            timeout = null;
            result = func.apply(context, args);
        };
        return function () {
            var now = new Date();
            var remaining = delay - (now - previous);
            context = this;  // eslint-disable-line consistent-this
            args = arguments;
            if (remaining <= 0) {
                clearTimeout(timeout);
                timeout = null;
                previous = now;
                result = func.apply(context, args);
            } else if (!timeout) {
                timeout = setTimeout(later, remaining + additionalTrailingDelay);
            }
            return result;
        };
    };
});

